module.exports = __webpack_public_path__ + "img/puerto-rico.fcec6063.svg";